import { createContext } from 'react';
import type { SegmentSchemaCatalog, SchemaSummaryWithFields } from '../../engage-segments-tab/types';

export interface SegmentSchemaCatalogContextValue {
  schemaCatalog: SegmentSchemaCatalog | undefined;
  isLoading: boolean;
  isRetrying: boolean;
  error: Error | null;
  retry: () => void;
  getSchemaById: (schemaId: string) => SchemaSummaryWithFields | undefined;
}

export const SegmentSchemaCatalogContext = createContext<SegmentSchemaCatalogContextValue | null>(null);
